import React from 'react'

export default function ContentWrapper(props) {
    return (
        <div className='p-4 max-w-full min-h-screen bg-gray-100'>
            <div className='mb-6'>
                <h1 className='relative text-[30px] font-bold pb-2 before:absolute before:bottom-0 before:w-[120px] before:h-[3px] before:bg-white before:rounded-md after:absolute after:bottom-0 after:left-0 after:rounded-md after:h-[3px] after:w-12 after:bg-black'>{props.title}</h1>
            </div>

            {props.children}
        </div>
    )
}

